import * as d3 from 'd3';
import BaseChart from './base.chart';

let colors = [
	["#f1eafe", "#FFB7B1", "#FF7469"], 
	["#BFA7FF", "#bd7dab", "#b85f74"], 
	["#8456FF", "#9553a9", "#673353"]
]

class Scatterplot extends BaseChart {

	logData() {
		console.log(this.data());
	}

	setup() {
		this.duration = 3000;
		this.prepareData();

		this.scale = window.devicePixelRatio; //voor scherp beeld

		this.canvas = this.graphicContainer
			.append("canvas");

		this.context = this.canvas.node().getContext("2d");

		this.min_x = d3.min(this.data(), d => d.properties["opleiding"]);
		this.max_x = d3.max(this.data(), d => d.properties["opleiding"]);
		this.min_y = d3.min(this.data(), d => d.properties["overgewicht"]);
		this.max_y = d3.max(this.data(), d => d.properties["overgewicht"]);

		this.setResponsive();
		
		return this;
	}

	highlightBuurt(gemeentecode, buurtcode) {
		this.gemeentecode = gemeentecode;
		this.draw({"gemeentecode": gemeentecode, "buurtcode": buurtcode});
	}

	highlightNone() {
		this.draw({"gemeentecode": this.gemeentecode});
	}

	fadeInGemeente(gemeentecode) {
		this.gemeentecode = gemeentecode;
		this.draw({"gemeentecode": gemeentecode});
	}

	fadeInNone() {
		this.gemeentecode = undefined;
		this.draw();
	}

	fadeInStedelijk() {
		this.draw({"stedelijkheid": true});
	}

	buildXAxis() {
		this.drawTransition({"axis": "x"});
	}

	buildBothAxes() {
		this.drawTransition();
	}

	render() {

		// makes the scatterplot square
		let minValue = Math.min(this.width(), this.height());

		this.width(minValue + this.margin().left + this.margin().right);
		this.height(minValue + this.margin().top + this.margin().bottom);

		this.canvas
			.attr("width", this.width() * this.scale)
			.attr("height", this.height() * this.scale)
			.style("width", this.width() + "px")
			.style("height", this.height() + "px");

		this.context.scale(this.scale, this.scale); //voor scherp beeld

		this.x_axis = d3.scaleLinear()
			.range([this.margin().left * 2, this.width() - (this.margin().right * 3)])
			.domain([this.min_x, 60])

		this.y_axis = d3.scaleLinear()
			.range([this.height() - (this.margin().bottom * 2), this.margin().top])
			.domain([this.min_y, this.max_y])


		return this;
	}

	draw(args) {
		this.context.clearRect(0, 0, this.width(), this.height());

		if (args && args.axis === "x") {
			this.drawXaxis();
		}
		else {
			this.drawAxes();
		}

		this.drawBollen(args);
		// this.drawRegressionLine(args);
	}

	drawTransition(args) {
		const landingsBasis = 0;
		const ease = d3.easeCubic;

		var t = d3.timer((elapsed) => {
			this.context.clearRect(0, 0, this.width(), this.height());

			if (args && args.axis === "x") {
				this.data().forEach((d) => {
					const time = Math.min(1, ease(elapsed / d.duration));
					const timeLeft = 1 - time;
					d.x = d.properties["opleiding"];
					d.y = landingsBasis + (this.max_y * timeLeft);
				});
			}
			else {
				let start = landingsBasis;
				this.data().forEach((d) => {
					const time = Math.min(1, ease(elapsed / d.duration));
					const timeLeft = 1 - time;
					d.y = (d.properties["overgewicht"] * time) + (start * timeLeft);
				});
			}
			

			if (args && args.axis === "x") {
				this.drawXaxis();
			}
			else {
				this.drawAxes();
			}

			this.drawBollen(args);
			const time = Math.min(1, ease(elapsed / this.duration));
			if (time === 1) {
				t.stop();
			}
		});
	}

	drawBollen(args) {
		//bollen
		this.data().forEach((d) => {
			if (d.properties["sted"] < 5 || args && args.gemeentecode === d.properties["GM_CODE"]) {
				let radius = 0;
				let alpha = 0;
				let kleur = this.findBiColor(d.properties["overgewicht"], d.properties["opleiding"]);

				if (!args || args.gemeentecode === undefined && args.stedelijkheid === undefined) { //alles tonen
					alpha = 0.7;
					radius = 3;
				}
				else if (args.gemeentecode === d.properties["GM_CODE"]) { //buurten in gemeente
					alpha = 1;
					radius = 5;
				}
				else if (args.stedelijkheid && d.properties["sted"] === 1 || args.stedelijkheid && d.properties["sted"] === 2) { //alles stedelijk
					alpha = 0.5;
					radius = 2;
				}
				else if (args.stedelijkheid) {
					alpha = 0;
				}
				else { //rest naar achtergrond
					alpha = 0.3;
					radius = 2;
				}

				if (args && args.axis === "x") {
					kleur = this.findXColor(d.properties["opleiding"]);
				}

				const x = this.x_axis(d.x);
				const y = this.y_axis(d.y);
				this.drawBol(x, y, kleur, radius, alpha)
			}
		});

		//evt highlight
		this.data().forEach((d) => {
			if (args && args.buurtcode !== undefined && args.buurtcode === d.properties["WK_CODE"] && args.gemeentecode === d.properties["GM_CODE"]) {
				const alpha = 1;
				const x = this.x_axis(d.x);
				const y = this.y_axis(d.y);
				const radius = 4;
				const kleur = "#FCF40B";
				this.drawBol(x, y, kleur, radius, alpha);

				this.context.font = "15px Relative, Arial";
				this.context.fillStyle = "#fff"
				this.context.textAlign = "center";
				this.context.fillText(d.properties["WK_NAAM"], this.x_axis(d.x), this.y_axis(d.y) - 15);
			}
		});
	}

	drawRegressionLine(args) {
		//lijn
		this.context.globalAlpha = 1;
		this.context.strokeStyle = "#FCF40B";
		this.context.lineWidth = 3;
		this.context.beginPath();
		const first = this.data()[0];

		if (args && args.stedelijkheid) { //alleen stedelijk
			this.context.moveTo(this.x_axis(first.properties["opleiding"]), this.y_axis(first.yhat_sted));
			this.data().forEach((d) => {
				this.context.lineTo(this.x_axis(d.properties["opleiding"]), this.y_axis(d.yhat_sted));
			})
		}
		else { //alles tonen
			this.context.moveTo(this.x_axis(first.properties["opleiding"]), this.y_axis(first.yhat));
			this.data().forEach((d) => {
				this.context.lineTo(this.x_axis(d.properties["opleiding"]), this.y_axis(d.yhat));
			})
		}
		this.context.stroke();
		this.context.lineWidth = 1;
	}

	drawAxes() {
		this.drawXaxis();
		this.drawYaxis();
	}

	drawXaxis() {
		//axis
		this.context.font = "10px Relative, Arial";
		this.context.strokeStyle = "#fff";
		this.context.fillStyle = "#fff";
		this.context.lineWidth = 1;

		for (let i=0; i<110; i = i + 10) {
			this.context.globalAlpha = .5;
			this.context.beginPath();
			this.context.moveTo(this.x_axis(i), 0);
			this.context.lineTo(this.x_axis(i), this.height() - this.margin().bottom - 10);
			this.context.stroke();

			this.context.globalAlpha = 1;
			this.context.textAlign = "center";
			this.context.fillText(i, this.x_axis(i), this.height() - 23);
		}

		this.context.font = "12px Relative, Arial";
		this.context.textAlign = "center";
		this.context.fillText("% laagopgeleiden", (this.width() / 2), this.height() - 5);
	}

	drawYaxis() {
		//axis
		this.context.font = "10px Relative, Arial";
		this.context.strokeStyle = "#fff";
		this.context.fillStyle = "#fff";
		this.context.lineWidth = 1;

		for (let i=0; i<110; i = i + 10) {
			this.context.globalAlpha = .5;
			this.context.beginPath();
			this.context.moveTo((this.margin().left * 2), this.y_axis(i));
			this.context.lineTo(this.width() - this.margin().left, this.y_axis(i));
			this.context.stroke();

			this.context.textAlign = "right";
			this.context.globalAlpha = 1;
			this.context.fillText(i, (this.margin().left * 2) - 10, this.y_axis(i) + 3);
		}
		this.context.font = "12px Relative, Arial";

		this.context.save();
		this.context.translate(0, this.height() / 2);
		this.context.rotate(-Math.PI/2);
		this.context.globalAlpha = 1;
		this.context.textAlign = "center";
		this.context.fillText("% inwoners met overgewicht", 0, 20);
		this.context.restore();
	}

	drawBol(x, y, kleur, radius, alpha) {
		this.context.strokeStyle = '#FFF';
		this.context.lineWidth = .1;

		this.context.globalAlpha = alpha;
		this.context.fillStyle = kleur;
		this.context.beginPath();
		this.context.moveTo(x, y);
		this.context.arc(x, y, radius, 0, 2 * Math.PI);
		this.context.fill();
		this.context.stroke();
	}

	colordomains(domains) {
		this.domains = domains;

		return this;
	}

	findBiColor(overgewicht, opgeleid) {
		const overgewicht_grenzen = [this.domains["overgewicht"][1], this.domains["overgewicht"][this.domains["overgewicht"].length - 2]];
		const opgeleid_grenzen = [this.domains["opleiding"][1], this.domains["opleiding"][this.domains["opleiding"].length - 3]];

		if (overgewicht === 0 || opgeleid === 0) {
			return "#07034A";
		}

		let overgewicht_kleur = 0;
		let opgeleid_kleur = 0;

		overgewicht_grenzen.forEach((d, i) => {
			if (overgewicht > d) {
				overgewicht_kleur = i + 1;
			}
		});

		opgeleid_grenzen.forEach((d, i) => {
			if (opgeleid > d) {
				opgeleid_kleur = i + 1;
			}
		});

		return colors[opgeleid_kleur][overgewicht_kleur];
	}

	findXColor(opgeleid) {
		const opgeleid_grenzen = [this.domains["opleiding"][1], this.domains["opleiding"][this.domains["opleiding"].length - 3]];

		if (opgeleid === 0) {
			return "#07034A";
		}

		let opgeleid_kleur = 0;

		opgeleid_grenzen.forEach((d, i) => {
			if (opgeleid > d) {
				opgeleid_kleur = i + 1;
			}
		});

		return colors[opgeleid_kleur][0];
	}

	prepareData() {
		this.data().forEach((d) => {
			//alles getallen 
			d.properties["opleiding"] = !isNaN(parseFloat(d.properties["opleiding"])) ? parseFloat(d.properties["opleiding"]) : 0;
			d.properties["overgewicht"] = !isNaN(parseFloat(d.properties["overgewicht"])) ? parseFloat(d.properties["overgewicht"]) : 0;

			//voor transition
			d.x = d.properties["opleiding"];
			d.y = d.properties["overgewicht"];
			d.duration = this.calcBiasedRandom();
		});

		let data = this.data().filter(d => d.properties.opleiding || d.properties.overgewicht);
		this.data(data);

		// perform regression 
		// fit line using coeffs
		const b = this.calcRegression(this.data());
		const b_sted = this.calcRegression(this.data().filter((d) => {
			return d.properties['sted'] < 5;
		}));

		this.data().forEach((d) => {
			//regression
			d.yhat = b.b0 + (d.properties["opleiding"] * b.b1);
			d.yhat_sted = b_sted.b0 + (d.properties["opleiding"] * b_sted.b1);
		})
	}

	calcBiasedRandom() {
		const min = this.duration * 0.1;
		const max = this.duration;
		const bias = this.duration * 0.9;
		const influence = 1;

		const rnd = Math.random() * (max - min) + min;
		const mix = Math.random() * influence;
		const value = rnd * (1 - mix) + bias * mix;

		return value;
	}

	calcRegression(data) {
		//regression line
		let x_mean = 0;
		let y_mean = 0;
		var term1 = 0;
		var term2 = 0;

		data.forEach((d) => {
			//optellen
			x_mean += d.properties["opleiding"];
			y_mean += d.properties["overgewicht"];
		});

		// calculate mean x and y
		x_mean /= data.length;
		y_mean /= data.length;

		// calculate coefficients
		var xr = 0;
		var yr = 0;
		data.forEach((d) => {
			xr = d.properties["opleiding"] - x_mean;
			yr = d.properties["overgewicht"] - y_mean;
			term1 += xr * yr;
			term2 += xr * xr;

		});
		var b1 = term1 / term2;
		var b0 = y_mean - (b1 * x_mean);

		return {"b1": b1, "b0": b0};
	}

	updateSvgSize() {
		// geen svg hier
	}

	resizeChart() {
		this.render();
	}
}

export default Scatterplot;
